import { render, staticRenderFns } from "./PublicWineryDashboard.vue?vue&type=template&id=710f3323&scoped=true"
import script from "./PublicWineryDashboard.vue?vue&type=script&lang=js"
export * from "./PublicWineryDashboard.vue?vue&type=script&lang=js"
import style0 from "./PublicWineryDashboard.vue?vue&type=style&index=0&id=710f3323&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710f3323",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('710f3323')) {
      api.createRecord('710f3323', component.options)
    } else {
      api.reload('710f3323', component.options)
    }
    module.hot.accept("./PublicWineryDashboard.vue?vue&type=template&id=710f3323&scoped=true", function () {
      api.rerender('710f3323', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/default/PublicWineryDashboard.vue"
export default component.exports